/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S4_Li3Inputs */

const en_guide_what_is_json_s4_li3 = /** @type {(inputs: Guide_What_Is_Json_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Data Storage</strong>: NoSQL databases like MongoDB store documents in JSON-like formats (BSON)`)
};

const ko_guide_what_is_json_s4_li3 = /** @type {(inputs: Guide_What_Is_Json_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>데이터 저장</strong>: MongoDB 같은 NoSQL 데이터베이스는 JSON과 유사한 포맷(BSON)으로 문서를 저장합니다`)
};

const ja_guide_what_is_json_s4_li3 = /** @type {(inputs: Guide_What_Is_Json_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>データストレージ</strong>: MongoDBなどのNoSQLデータベースはJSON形式（BSON）でドキュメントを保存します`)
};

/**
* | output |
* | --- |
* | "<strong>Data Storage</strong>: NoSQL databases like MongoDB store documents in JSON-like formats (BSON)" |
*
* @param {Guide_What_Is_Json_S4_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s4_li3 = /** @type {((inputs?: Guide_What_Is_Json_S4_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S4_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s4_li3(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s4_li3(inputs)
	return ja_guide_what_is_json_s4_li3(inputs)
});